<!-- Estilos: src/assets/styles/components/_liga-ui.scss (sistema .lx-*) y _liga-b.scss (.lxb-*). -->
<section class="lx-pagina" lang="es" [class.lx-pagina--con-cta]="ctaFijo && !guardado && !configuracionInvalida">
  <p class="lx-sr" role="status" aria-live="polite">{{anuncio}}</p>

  <!-- Qué se pide, cuánto toma y cuánto falta -->
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono" [class.lx-hero__icono--verde]="guardado" aria-hidden="true">
        <fa-icon [icon]="guardado ? iconos.listo : iconoHero"></fa-icon>
      </span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">{{guardado ? 'Paso completado' : eyebrow}}</span>
        <h2 class="lx-hero__titulo">{{titulo}}</h2>
        <p class="lx-hero__subtitulo" *ngIf="!guardado && !configuracionInvalida">{{subtitulo}}</p>
        <span class="lx-chip lx-chip--listo" *ngIf="guardado"><fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon>{{estados.listo.texto}}</span>
        <ng-container *ngIf="!guardado">
          <span class="lx-chip" *ngIf="estadoHero as e" [ngClass]="estados[e].chip">
            <fa-icon *ngIf="estados[e].icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estados[e].texto}}
          </span>
        </ng-container>
      </div>
    </div>

    <div class="lx-avance lx-avance--chica" *ngIf="mostrarAvance && !guardado && !configuracionInvalida">
      <div class="lx-avance__fila">
        <span><strong>{{avance.listos}} de {{avance.total}}</strong> obligatorios listos</span>
        <span class="lx-avance__pct">{{avance.pct}} %</span>
      </div>
      <div class="lx-avance__barra" role="progressbar" aria-label="Avance del formulario" aria-valuemin="0"
           [attr.aria-valuemax]="avance.total" [attr.aria-valuenow]="avance.listos"
           [attr.aria-valuetext]="avance.listos + ' de ' + avance.total + ' datos obligatorios listos'">
        <span class="lx-avance__relleno" [style.width.%]="avance.pct"></span>
      </div>
      <button type="button" class="lx-avance__siguiente" *ngIf="avance.siguiente as siguiente; else todoListo" (click)="enfocar(siguiente)">
        <fa-icon [icon]="iconos.flecha" aria-hidden="true"></fa-icon>
        <span>Siguiente: <strong>{{siguiente.etiqueta}}</strong><ng-container *ngIf="grupos.length > 1 && siguiente.grupo"> · {{siguiente.grupo}}</ng-container></span>
        <fa-icon [icon]="iconos.chevron" aria-hidden="true"></fa-icon>
      </button>
      <ng-template #todoListo>
        <p class="lx-avance__siguiente lxb-listo">
          <fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon>
          <span>Todo listo: <strong>revisa y guarda</strong></span>
        </p>
      </ng-template>
    </div>
  </header>

  <!-- El paso regresó con motivo de rechazo -->
  <div class="lx-alerta lx-alerta--error" *ngIf="data.comment && !guardado">
    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
    <div class="lx-alerta__cuerpo">
      <p class="lx-alerta__titulo">Necesitamos que corrijas algo</p>
      <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
    </div>
  </div>

  <!-- Referencias: el backend pide teléfonos distintos y puede mandarles un SMS -->
  <div class="lx-alerta lx-alerta--info" *ngIf="tieneReferencias && !guardado">
    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.sms"></fa-icon></span>
    <div class="lx-alerta__cuerpo">
      <p class="lx-alerta__titulo">Avísales a tus referencias</p>
      <p class="lx-alerta__texto">Podemos mandarles un SMS para que confirmen que te conocen. Usa números distintos entre sí y al tuyo.</p>
    </div>
  </div>

  <!-- No se guardó: en línea, con lo que dijo el servidor -->
  <div class="lx-alerta lx-alerta--error lxb-aviso-error lxb-enfocable" role="alert" tabindex="-1" *ngIf="avisoError as aviso">
    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
    <div class="lx-alerta__cuerpo">
      <p class="lx-alerta__titulo">{{aviso.titulo}}</p>
      <p class="lx-alerta__texto">{{aviso.texto}}</p>
    </div>
    <button type="button" class="lx-alerta__cerrar" aria-label="Cerrar aviso" (click)="cerrarAviso()">
      <fa-icon [icon]="iconos.cerrar"></fa-icon>
    </button>
  </div>

  <div class="lx-vacio" *ngIf="configuracionInvalida; else contenido">
    <span class="lx-vacio__icono" aria-hidden="true"><fa-icon [icon]="iconos.aviso"></fa-icon></span>
    <h3 class="lx-vacio__titulo">No pudimos abrir este formulario</h3>
    <p class="lx-vacio__texto">Regresa a tus pasos e inténtalo de nuevo. Si sigue igual, avísale a tu asesor.</p>
    <button type="button" class="lx-btn lx-btn--primario" (click)="volverALista()"><span>Volver a mis pasos</span></button>
  </div>

  <ng-template #contenido>
    <!-- Guardado: palomita y regreso a la lista -->
    <div class="lx-celebracion" *ngIf="guardado; else formulario">
      <div class="lx-celebracion__check">
        <svg class="lx-check" viewBox="0 0 52 52" aria-hidden="true">
          <circle class="lx-check__circulo" cx="26" cy="26" r="25"></circle>
          <path class="lx-check__trazo" d="M15 27.5l7 7 15-16"></path>
        </svg>
      </div>
      <h3 class="lx-celebracion__titulo">¡Listo! Guardamos tu información</h3>
      <p class="lx-celebracion__msg">{{mensajeExito}}</p>
      <button type="button" class="lx-btn lx-btn--primario" (click)="continuar()"><span>Continuar</span></button>
      <p class="lx-celebracion__nota">Te regresamos a tus pasos en unos segundos.</p>
    </div>
  </ng-template>

  <ng-template #formulario>
    <form class="lx-tarjeta" [formGroup]="entity" (ngSubmit)="guardar()" novalidate>
      <div class="lx-form">
        <ng-container *ngFor="let grupo of grupos; trackBy: porClave">
          <!-- Un tema por grupo (los SEPARATOR de la configuración) -->
          <fieldset class="lx-grupo" *ngIf="grupoVisible(grupo)">
            <legend class="lx-grupo__titulo" *ngIf="grupo.titulo">
              <fa-icon [icon]="grupo.icono" aria-hidden="true"></fa-icon>
              <span class="lxb-leyenda">{{grupo.titulo}}</span>
              <ng-container *ngIf="grupos.length > 1 && conteoGrupo[grupo.clave] as conteo">
                <span class="lx-chip lx-chip--listo" *ngIf="conteo.total && conteo.listos === conteo.total">
                  <fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon>{{estados.listo.texto}}
                </span>
                <span class="lx-chip lx-chip--suave" *ngIf="conteo.total && conteo.listos < conteo.total">
                  {{conteo.listos}}/{{conteo.total}}<span class="lx-sr"> datos listos</span>
                </span>
              </ng-container>
            </legend>
            <p class="lx-grupo__texto" *ngIf="grupo.subtitulo">{{grupo.subtitulo}}</p>

            <ng-container *ngFor="let campo of grupo.campos; trackBy: porId">
              <div class="lx-campo" *ngIf="shouldShowField(campo.input)" [class.is-invalido]="invalido(campo)">
                <label class="lx-campo__etiqueta" *ngIf="campo.tipo !== 'opciones'; else etiquetaOpciones" [for]="campo.domId">
                  {{campo.etiqueta}}<span class="lx-campo__opcional" *ngIf="!campo.obligatorio"> (opcional)</span>
                </label>
                <ng-template #etiquetaOpciones>
                  <span class="lx-campo__etiqueta" [id]="campo.domId + '-etiqueta'">
                    {{campo.etiqueta}}<span class="lx-campo__opcional" *ngIf="!campo.obligatorio"> (opcional)</span>
                  </span>
                </ng-template>

                <ng-container [ngSwitch]="campo.tipo">
                  <p-inputMask *ngSwitchCase="'telefono'" [inputId]="campo.domId" [formControlName]="campo.id"
                               mask="99 9999 9999" [unmask]="true" [autoClear]="false" type="tel"
                               [placeholder]="campo.placeholder" [autocomplete]="campo.autocomplete"
                               [ariaRequired]="campo.obligatorio"></p-inputMask>

                  <p-inputNumber *ngSwitchCase="'numero'" [inputId]="campo.domId" [formControlName]="campo.id"
                                 mode="decimal" locale="es-MX" [useGrouping]="true" [maxFractionDigits]="2"
                                 [placeholder]="campo.placeholder" (onFocus)="seleccionarTodo($event)"></p-inputNumber>

                  <p-inputNumber *ngSwitchCase="'moneda'" [inputId]="campo.domId" [formControlName]="campo.id"
                                 mode="currency" currency="MXN" locale="es-MX"
                                 [placeholder]="campo.placeholder || '$0.00'" (onFocus)="seleccionarTodo($event)"></p-inputNumber>

                  <p-calendar *ngSwitchCase="'fecha'" [inputId]="campo.domId" [formControlName]="campo.id"
                              [showIcon]="true" appendTo="body" panelStyleClass="lx-panel" dateFormat="dd/mm/yy"
                              [placeholder]="campo.placeholder || 'dd/mm/aaaa'"></p-calendar>

                  <p-dropdown *ngSwitchCase="'lista'" [inputId]="campo.domId" [formControlName]="campo.id"
                              [options]="campo.opciones" optionLabel="label" optionValue="value"
                              placeholder="Elige una opción" appendTo="body" panelStyleClass="lx-panel"
                              [filter]="campo.filtro" filterPlaceholder="Busca una opción"
                              emptyFilterMessage="No encontramos esa opción" emptyMessage="Sin opciones"></p-dropdown>

                  <div *ngSwitchCase="'opciones'" class="lx-opciones" [class.lxb-opciones--2]="campo.dosColumnas"
                       role="radiogroup" [id]="campo.domId" [attr.aria-labelledby]="campo.domId + '-etiqueta'"
                       [attr.aria-describedby]="tienePie(campo) ? campo.domId + '-pie' : null">
                    <label class="lx-opcion" *ngFor="let opcion of campo.opciones" [class.is-elegida]="elegida(campo, opcion.value)">
                      <input class="lx-opcion__input" type="radio" [formControlName]="campo.id" [name]="campo.id" [value]="opcion.value">
                      <span class="lx-opcion__marca" aria-hidden="true"></span>
                      <span class="lx-opcion__textos"><span class="lx-opcion__titulo">{{opcion.label}}</span></span>
                    </label>
                  </div>

                  <input *ngSwitchDefault class="lx-control" [class.lxb-mayusculas]="campo.mayusculas"
                         [id]="campo.domId" [type]="campo.tipoHtml" [formControlName]="campo.id"
                         [placeholder]="campo.placeholder"
                         [attr.maxlength]="campo.soloDigitos ? null : campo.maxLength"
                         [attr.inputmode]="campo.inputmode" [attr.pattern]="campo.soloDigitos ? '[0-9]*' : null"
                         [attr.autocomplete]="campo.autocomplete" [attr.autocapitalize]="campo.autocapitalize"
                         autocorrect="off" spellcheck="false"
                         [attr.aria-required]="campo.obligatorio" [attr.aria-invalid]="invalido(campo)"
                         [attr.aria-describedby]="tienePie(campo) ? campo.domId + '-pie' : null"
                         (input)="alEscribir(campo, $event)" (keyup)="alSoltarTecla(campo)" (blur)="alSalir(campo)">
                </ng-container>

                <!-- Error (al salir del campo o al intentar guardar), cómo llenarlo y contador -->
                <div class="lx-campo__pie" [id]="campo.domId + '-pie'" *ngIf="tienePie(campo)">
                  <div class="lxb-pie">
                    <p class="lx-campo__error" *ngIf="invalido(campo)">
                      <fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon><span>{{mensajeError(campo)}}</span>
                    </p>
                    <p class="lx-campo__ayuda" *ngIf="campo.ayuda">{{campo.ayuda}}</p>
                  </div>
                  <span class="lx-campo__contador" *ngIf="campo.contador" aria-hidden="true">{{largo(campo)}}/{{campo.maxLength}}</span>
                </div>
              </div>
            </ng-container>
          </fieldset>
        </ng-container>
      </div>

      <div class="lx-cta lxb-cta-tarjeta" *ngIf="!ctaFijo">
        <ng-container *ngTemplateOutlet="botonGuardar"></ng-container>
        <p class="lxb-nota" [class.lxb-nota--lista]="!avance.faltan && !guardando">
          <fa-icon [icon]="guardando ? iconos.seguro : avance.faltan ? iconos.info : iconos.listo" aria-hidden="true"></fa-icon>
          <span>{{guardando ? 'No cierres esta pantalla.' : notaCta}}</span>
        </p>
      </div>
    </form>
  </ng-template>

  <p class="lx-seguro">
    <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
    <span>Tus datos viajan cifrados y solo se usan para tu solicitud.</span>
  </p>
</section>

<!-- Botón principal fijo abajo (hermano de la página: nada animado por encima) -->
<div class="lx-cta-fijo" *ngIf="ctaFijo && !guardado && !configuracionInvalida">
  <ng-container *ngTemplateOutlet="botonGuardar"></ng-container>
  <p class="lx-cta-fijo__nota" [class.lxb-nota--lista]="!avance.faltan && !guardando">
    <fa-icon [icon]="guardando ? iconos.seguro : avance.faltan ? iconos.info : iconos.listo" aria-hidden="true"></fa-icon>
    <span>{{guardando ? 'No cierres esta pantalla.' : notaCta}}</span>
  </p>
</div>

<ng-template #botonGuardar>
  <button type="button" class="lx-btn lx-btn--primario" [class.is-cargando]="guardando" [attr.aria-busy]="guardando" (click)="guardar()">
    <span class="lx-spinner" *ngIf="guardando" aria-hidden="true"></span>
    <span>{{guardando ? 'Guardando…' : textoBoton}}</span>
  </button>
</ng-template>
